// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"799":"496c1562","867":"b8c53be3","2717":"d720a3be","3256":"18ade6ab","4381":"b64f071c","5283":"624580f8","5770":"a8e04ecd","6264":"33f50ac7","6483":"9f34bc12"}[chunkId] + ".chunk.css";
};